import moment from 'moment-timezone';
// import {debounce} from 'lodash';

import React, { useState, useEffect, useContext } from 'react';

import { FormControl, InputLabel, Select, MenuItem,  TextField, Input, Button  } from '@material-ui/core'

import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';


import { makeStyles } from '@material-ui/core/styles';

import { getProductCategories, getStatuses,getBulkActionTypes , getCodeSentValuesArray, providerItemStatusArray} from '../common/global'

import { BulkActionsContext, BulkActionsProvider } from './BulkActions/BulkActionsContext'
import BookingsGrid from './BulkActions/BookingsGrid';

import ProductSearch from './BulkActions/ProductSearch';

import api from './BulkActions/Api';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@material-ui/core';
import filters from 'components/common/reducers/filters';


const theme = createTheme({
    typography: {
        fontFamily: 'gilroy-regular',
        fontSize: 14,
        color: '#434F69'
    },
    palette: {
        text: {
            primary: '#434F69',
            //   secondary: styles.tt,
            //   disabled: styles.ttt,
            //   hint: styles.tttt,
        },
    }
})

const useStyles = makeStyles((theme) => ({
    root: {
        color: '#434F69',
    },
    heading: {
        fontSize: 28,
        fontWeight: '500',
        lineHeight: '28px',
        color: '#434F69',
        width: '100%',
        padding: '8px'
    },
    title: {
        fontSize: 20,
        fontWeight: 500,
        letterSpacing: 0,
        lineHeight: '28px'
    },
    container: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        height: ' 100%',
        backgroundColor: 'white',
        border: '1px solid #ccc',
        textAlign: 'center',
        borderCollapse: 'collapse',
        overflowY: 'hidden',
        width: '100%'
    },

    header: {
        justifySelf: 'flex-start',
        padding: '8px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignContent: 'flex-start',
        margin: '10px 20px',
        border: '1px solid #ccc',
        borderRadius: '5px',
        backgroundColor: '#fff'
    },

    content: {
        flex: '1 0 auto',
        height: '100%',
        minHeight: '300px',

        border: '1px solid black',
        padding: '8px',
        overflowY: 'scroll',
        width: '100%'
    },
    searchContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        textAlign: 'right'
    },
    hqIdField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 120,
    },
    dateField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 160,
    },
    countryField: {
        width: 140
    },
    bulkAction:{
        marginLeft: theme.spacing(2.5),
        marginTop: theme.spacing(1),
    }

}));




export default function BulkActionsPage({onSelectACDrawerMenuItemFunc, ...props}) {
    const classes = useStyles();
    const [bulkAssign,setBulkAssign]= useState('Assign an Owner')
    const [resetFilter,setResetFilter] = useState(1);
    const bulkOptions = getBulkActionTypes();
    const handleChangeBulkAssign = (e) => {
         setBulkAssign(e.target.value || '');
         }
    const isBulKAssignOwner = bulkAssign ==='Assign an Owner';
    const handleClose =()=>{ setResetFilter(resetFilter+1)}
    const [productSearchText, setProductSearchText] = useState()
    
    function onSearchTextChanged(text) {
        setProductSearchText(text)
        
    }
   

    return (
         <ThemeProvider theme={theme}>
            <BulkActionsProvider>
                <div style={{ display: 'flex', width: '100%' }} className={classes.root}>
                    <div style={{ width: '300px', backgroundColor: '#fff', borderRight: '1px solid #eee', flex: '0' }} >
                        <ProductSearch resetFilter={resetFilter} classes={classes} onSearchTextChanged={onSearchTextChanged}/>
                    </div>
                    <div className={classes.container} style={{ flex: 1, backgroundColor: 'rgb(242, 244, 246)' }}>  
                        <div style={{ display:'flex', alignItems:'center',justifyContent:'space-between'}}>
                        <div style={{ display:'flex', alignItems:'center',justifyContent:'flex-start'}}>
                        <span className={classes.bulkAction} style={{fontSize:'16px'}}>Bulk action:</span>
                        <FormControl variant='outlined' label="Bulk Action" size="small">
                            <Select
                                value={bulkAssign}
                                placeholder='Bulk Action'
                                label="Bulk Action"
                                className={classes.bulkAction}
                                onChange={handleChangeBulkAssign}
                            >
                                {bulkOptions.map((s) =>
                                    (<MenuItem key={s} value={s}>{s}</MenuItem>)
                                )}
                            </Select>
                        </FormControl>  
                        </div> 
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                        </div>           
                        <BookingsFilter resetFilter={resetFilter} isBulKAssignOwner={isBulKAssignOwner} bulkAssign={bulkAssign} productSearchText={productSearchText}/>
                        <BookingsGrid className={classes.content} clearFilter={resetFilter} isBulKAssignOwner={isBulKAssignOwner} bulkAssign={bulkAssign} onSelectACDrawerMenuItemFunc={onSelectACDrawerMenuItemFunc} loggedInUser={props.authProperties.loggedInUser.givenName}/>
                    </div>
                </div>
            </BulkActionsProvider>
        </ThemeProvider>

    )
}










function BookingsFilter({resetFilter,isBulKAssignOwner,bulkAssign,productSearchText}) {
    const initalStartDate = moment().startOf('day');
    const initalEndDate = initalStartDate.clone().add(10, 'd');
    const [startDate, setStartDate] = useState(initalStartDate);
    const [endDate, setEndDate] = useState(initalEndDate);
    const classes = useStyles();
    const statusList = getStatuses('booking') || [];
    const CategoryList = getProductCategories()||[];
    const codeSentOptions = getCodeSentValuesArray();
    const providerItemStatus = providerItemStatusArray();
    const { dispatch } = useContext(BulkActionsContext);
    const [locationData, setLocationData] = useState({ countries: [], states: [], cities: [] });
    const [selectedCountries, setSelectedCountries] = useState([]);
    const [selectedStates, setSelectedStates] = useState([]);
    const [selectedCities, setSelectedCities] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(['tentative', 'booked', 'confirmed']);
    const [selectedCategory,setSelectedCategory] = useState(['external']);
    const [selectedCodeSent,setSelectedCodeSent] = useState(false);
    const [selectedProviderItemStatus,setselectedProviderItemStatus] = useState(['completed','requested-completed']);
    const [selectedOwner,setSelectedOwner] = useState([]);
    const [staffList,setStaffList] = useState([]);
    const [filtersUpdated, setFiltersUpdated] = useState(true); // We don't do an inital data load, so indicate that a search needs to be performed
    
    
    useEffect(() => {
        filters.productName=productSearchText
    }, [productSearchText])
    
   

    useEffect(() => {
        const getData = async () => {
            const data = await api.getStaff();
            setStaffList(data);
        };

        getData();
    }, []);



    // const debouncedSearch = debounce(function (query) {
    //     console.log('BLK : debounce : ', query)
    //     // dispatch('setBookingFilter', query)
    // }, 1000);


    const startDateChanged = (e) => {
        const newDate = moment(e.target.value);
        console.log('BLK-FilterPanel StartDate Changed', newDate.format())
        setStartDate(newDate);
    }

    const endDateChanged = (e) => {
        const newDate = moment(e.target.value);
        console.log('BLK-FilterPanel EndDate Changed', newDate.format())
        setEndDate(newDate);
    }

    // useEffect(() => {
        
    // }, [startDate, endDate, selectedCities, selectedCountries, selectedStates, selectedStatus, dispatch,selectedCategory,selectedOwner,selectedProviderItemStatus,selectedCodeSent,bulkAssign])
    function applyFilters() {
        let filters = { startDate: startDate, endDate: endDate, status: selectedStatus, productName: productSearchText }
        

        switch (bulkAssign) {
            case 'Assign an Owner':
                filters.cities = selectedCities;
                filters.states = selectedStates;
                filters.countries = selectedCountries;
                filters.category = selectedCategory;
                // filters.providerItemStatus=selectedProviderItemStatus;

                break;
            case 'Send gameplay':
                filters.owners = selectedOwner;
                filters.codeSent = selectedCodeSent;
                filters.category = selectedCategory;
                filters.providerItemStatus = selectedProviderItemStatus;
                break;
            case 'Assign Routes':
                filters.owners = selectedOwner;
                break;
            default:
                break;

        }
        dispatch({ type: 'setBookingFilter', filter: filters })
        setFiltersUpdated(false);
    }

    useEffect(() => {
        async function getData() {
            const locations = await api.getLocationData();
            console.log('got locations : ', locations)

            setLocationData({ countries: locations.countries?.sort() || [], states: locations.states?.sort() || [], cities: locations.cities.sort() });
        }

        getData();
    }, [])
    
    useEffect(() => {
        setSelectedCountries([]);
        setSelectedCities([]);
        setSelectedStates([]);
        setSelectedStatus(['tentative', 'booked', 'confirmed']);
        setSelectedCategory(['external']);
        setSelectedOwner([]);
        setSelectedCodeSent(false);
        setselectedProviderItemStatus(['completed', 'requested-completed'])
    }, [resetFilter])


    // TODO: the logic for setFilterActive (changing the color of the search button) should be a bit more nuanced.
    // We should only activate the search button when the filters have actually changed to a new value
    // Not simply on the change event
    const handleCountriesChange = (e) => { setSelectedCountries(e.target.value || []); setFiltersUpdated(true);}
    const handleStatesChange = (e) => { setSelectedStates(e.target.value || []); setFiltersUpdated(true);}
    const handleCitiesChange = (e) => { setSelectedCities(e.target.value || []); setFiltersUpdated(true);}
    const handleStatusChange = (e) => { setSelectedStatus(e.target.value || []); setFiltersUpdated(true);}
    const handleCategoryChange = (e) => { setSelectedCategory(e.target.value || []); setFiltersUpdated(true);}
    const handleCodeSentChange = (e) => { setSelectedCodeSent(e.target.value || false); setFiltersUpdated(true);}
    const handleOwnerChange = (e) => { setSelectedOwner(e.target.value || []); setFiltersUpdated(true);}
    const handleProviderItemStatusChange = (e) => { setselectedProviderItemStatus(e.target.value || []); setFiltersUpdated(true);}


    const getDesiredFilters = (bulkAssign) => {

        switch (bulkAssign) {
            case 'Assign an Owner':
                return (
                    <>
                        <FormControl variant="outlined" className={classes.formControl} size="small">
                            <InputLabel>Country</InputLabel>
                            <Select
                                value={selectedCountries}
                                label="Country"
                                className={classes.countryField}
                                input={<Input />}
                                onChange={handleCountriesChange}
                                multiple
                            >
                                {locationData?.countries.map(c => (<MenuItem key={c} value={c}>{c}</MenuItem>))}
                            </Select>
                        </FormControl>


                        <FormControl variant="outlined" className={classes.formControl} size="small">
                            <InputLabel>State</InputLabel>
                            <Select
                                value={selectedStates}
                                label="State"
                                className={classes.countryField}
                                input={<Input />}
                                onChange={handleStatesChange}
                                multiple
                            >
                                {locationData?.states.map(c => (<MenuItem key={c} value={c}>{c}</MenuItem>))}

                            </Select>
                        </FormControl>

                        <FormControl variant="outlined" className={classes.formControl} size="small">
                            <InputLabel>City</InputLabel>
                            <Select
                                value={selectedCities}
                                label="City"
                                className={classes.countryField}
                                input={<Input />}
                                onChange={handleCitiesChange}
                                multiple
                            >
                                {locationData?.cities.map(c => (<MenuItem key={c} value={c}>{c}</MenuItem>))}
                            </Select>
                        </FormControl>
                        <FormControl variant="outlined" className={classes.formControl} size="small">
                            <InputLabel>Booking Status</InputLabel>
                            <Select
                                value={selectedStatus}
                                label="Booking Status"
                                className={classes.countryField}
                                multiple
                                input={<Input />}
                                onChange={handleStatusChange}
                            >
                                {statusList.map((s) =>
                                    (<MenuItem key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</MenuItem>)
                                )}
                            </Select>
                        </FormControl>
                        <FormControl variant="outlined" className={classes.formControl} size="small">
                            <InputLabel>Category</InputLabel>
                            <Select
                                value={selectedCategory}
                                label="Category"
                                className={classes.countryField}
                                multiple
                                input={<Input />}
                                onChange={handleCategoryChange}
                            >
                                {CategoryList.map((s) =>
                                    (<MenuItem key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</MenuItem>)
                                )}
                            </Select>
                        </FormControl>

                    </>)
            case 'Send gameplay':
                return (
                    <>
                        <FormControl variant="outlined" className={classes.formControl} size="small">
                            <InputLabel>Owner</InputLabel>
                            <Select
                                value={selectedOwner}
                                label="Owner"
                                className={classes.countryField}
                                input={<Input />}
                                onChange={handleOwnerChange}
                                multiple
                            >
                                {staffList.map(s => (<MenuItem id={s.id} value={s.id}>{s.name}</MenuItem>))}
                            </Select>
                        </FormControl>


                        <FormControl variant="outlined" className={classes.formControl} size="small">
                            <InputLabel>Provider Item Status</InputLabel>
                            <Select
                                value={selectedProviderItemStatus}
                                label="Provider Item Status"
                                className={classes.countryField}
                                input={<Input />}
                                onChange={handleProviderItemStatusChange}
                                multiple
                            >
                                {providerItemStatus.map(c => (<MenuItem key={c.label} value={c.value}>{c.label}</MenuItem>))}

                            </Select>
                        </FormControl>

                        <FormControl variant="outlined" className={classes.formControl} size="small">
                            <InputLabel>Code sent</InputLabel>
                            <Select
                                value={selectedCodeSent}
                                label="Code sent"
                                className={classes.countryField}
                                input={<Input />}
                                onChange={handleCodeSentChange}
                            >
                                {codeSentOptions.map(c => (<MenuItem key={c.value} value={c.value}>{c.label}</MenuItem>))}
                            </Select>
                        </FormControl>
                        <FormControl variant="outlined" className={classes.formControl} size="small">
                            <InputLabel>Booking Status</InputLabel>
                            <Select
                                value={selectedStatus}
                                label="Booking Status"
                                className={classes.countryField}
                                multiple
                                input={<Input />}
                                onChange={handleStatusChange}
                            >
                                {statusList.map((s) =>
                                    (<MenuItem key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</MenuItem>)
                                )}
                            </Select>
                        </FormControl>
                        <FormControl variant="outlined" className={classes.formControl} size="small">
                            <InputLabel>Category</InputLabel>
                            <Select
                                value={selectedCategory}
                                label="Category"
                                className={classes.countryField}
                                multiple
                                input={<Input />}
                                onChange={handleCategoryChange}
                            >
                                {CategoryList.map((s) =>
                                    (<MenuItem key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</MenuItem>)
                                )}
                            </Select>
                        </FormControl>

                    </>
                )
            case 'Assign Routes':
                return (
                    <>
                        <FormControl variant="outlined" className={classes.formControl} size="small">
                            <InputLabel>Owner</InputLabel>
                            <Select
                                value={selectedOwner}
                                label="Owner"
                                className={classes.countryField}
                                input={<Input />}
                                onChange={handleOwnerChange}
                                multiple
                            >
                                {staffList.map(s => (<MenuItem id={s.id} value={s.id}>{s.name}</MenuItem>))}
                            </Select>
                        </FormControl>
                        <FormControl variant="outlined" className={classes.formControl} size="small">
                            <InputLabel>Booking Status</InputLabel>
                            <Select
                                value={selectedStatus}
                                label="Booking Status"
                                className={classes.countryField}
                                multiple
                                input={<Input />}
                                onChange={handleStatusChange}
                            >
                                {statusList.map((s) =>
                                    (<MenuItem key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</MenuItem>)
                                )}
                            </Select>
                        </FormControl>
                    </>
                )
            default:
                console.log(`Sorry, we are out of .`);
        }
    }


    return (
        <>
            <div className={classes.header}>
                <TextField
                    id="date"
                    label="Start"
                    type="date"
                    defaultValue={startDate.format('YYYY-MM-DD')}
                    className={classes.dateField}
                    size="small"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    onChange={startDateChanged}
                />
                <TextField
                    id="date"
                    label="End"
                    type="date"
                    size="small"
                    defaultValue={endDate.format('YYYY-MM-DD')}
                    className={classes.dateField}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    onChange={endDateChanged}
                />
                {
                    getDesiredFilters(bulkAssign)
                }
                <Button variant="contained" color={filtersUpdated ? 'secondary' : 'primary'} style={{ marginLeft: "auto" }} onClick={applyFilters}>{ filtersUpdated ? 'Search' : 'Refresh' }</Button>
            </div>
        </>
    )

}



